import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CodeFilledSvg from "@ant-design/icons-svg/es/asn/CodeFilled";
import AntdIcon from "../components/AntdIcon";
var CodeFilled = function CodeFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodeFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CodeFilled.displayName = 'CodeFilled';
}
export default /*#__PURE__*/React.forwardRef(CodeFilled);